module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781618371621_0059_001",
      "src": "Images/9781618371621_0059_001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap",
    attrs: {
      "id": "d7e2041659"
    }
  }, [_vm._v("Cool Cucumber Soup")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e2042159"
    }
  }, [_c('b', [_vm._v("COOL CUCUMBER SOUP")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e2042659"
    }
  }, [_c('b', [_c('i', [_vm._v("Homemade curry oil adds a taste of the tropics to this summer favorite.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e2043659"
    }
  }, [_c('b', [_vm._v("Prep: 25 minutes plus chilling Cook: 3 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2044259"
    }
  }, [_vm._v("2 English (seedless) cucumbers "), _c('br'), _vm._v(" (about 12 ounces each), peeled")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2044859"
    }
  }, [_vm._v("1 small garlic clove, crushed with garlic press")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2045159"
    }
  }, [_vm._v("2 cups (16 ounces) plain low-fat yogurt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2045459"
    }
  }, [_vm._v("½ cup low-fat (1%) milk")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2046459"
    }
  }, [_vm._v("1 tablespoon fresh lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2046759"
    }
  }, [_vm._v("1¼ teaspoons salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2047859"
    }
  }, [_vm._v("2 tablespoons olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2048259"
    }
  }, [_vm._v("½ teaspoon curry powder")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2049159"
    }
  }, [_vm._v("½ teaspoon ground cumin")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2050159"
    }
  }, [_vm._v("¼ teaspoon crushed red pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2051059"
    }
  }, [_vm._v("1 small tomato, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2051359"
    }
  }, [_vm._v("1 tablespoon sliced fresh mint leaves")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e2051859"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Prepare soup: Cut enough cucumber into ¼-inch pieces to equal ½ cup; reserve for garnish. Cut remaining cucumbers into 2-inch pieces. In food processor with knife blade attached or in blender, puree large cucumber pieces, garlic, yogurt, milk, lemon juice, and salt until almost smooth. Pour mixture into medium bowl; cover and refrigerate until cold, at least 2 hours.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2056559"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Meanwhile, prepare curry oil: In small saucepan, heat oil over low heat. Stir in curry powder, cumin, and crushed red pepper; cook until fragrant and oil is hot, about 3 minutes. Remove saucepan from heat; strain curry oil through sieve into cup.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2058559"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Prepare garnish: In small bowl, combine tomato and reserved cucumber.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2059659"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" To serve, stir soup and ladle into bowls. Garnish each with spoonful of cucumber mixture; sprinkle with mint and drizzle with curry oil. Makes about 4 cups or 4 first-course servings.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e2061459"
    }
  }, [_vm._v("Each serving: About 170 calories, 8g protein, 15g carbohydrate, 9g total fat (2g saturated), 8mg cholesterol, 830mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-647fb11f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c57_r1.vue
// module id = 237
// module chunks = 0